import React, { useEffect, useState } from 'react';

import PortalSelector from '../../../components/portalSelector';

import './styles.scss';

const CreatePortalBody = ({ portalInfo, onChangeCB }) => {
  const [displayName, setDisplayName] = useState(portalInfo?.displayName || '');
  const [selectedPortal, setSelectedPortal] = useState(portalInfo?.selectedPortal || null);
  const [method, setMethod] = useState(portalInfo?.method || 'create');

  useEffect(() => {
    if (method === 'create') {
      onChangeCB({ ...portalInfo, method, displayName });
      return;
    } else if (method === 'select') {
      onChangeCB({ ...portalInfo, method, selectedPortal });
      return;
    }
  }, [displayName, selectedPortal, method]);

  const handleChangeMethod = () => {
    setMethod(method === 'create' ? 'select' : 'create');
  };

  const renderSelectPortal = () => {
    return (
      <div className="form-group">
        <label>Select a Portal</label>
        <PortalSelector
          outline
          onSelection={setSelectedPortal}
          customSelected={
            selectedPortal
              ? { label: selectedPortal.label, value: selectedPortal.value }
              : { label: 'Select a portal', value: null }
          }
        />
      </div>
    );
  };

  const renderCreateNewPortal = () => {
    return (
      <div className="form-group">
        <label>Portal Name</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter portal name"
          value={displayName}
          onChange={e => setDisplayName(e.target.value)}
        />
        <p style={{ fontSize: 14, marginTop: 10 }}>
          To configure a Portal in details, go to the{' '}
          <a style={{ fontSize: 14 }} href="/#/portals">
            Portals
          </a>{' '}
          section in the sidebar after creating the Campaign.
        </p>
      </div>
    );
  };

  return (
    <div className="create-portal-body">
      {method === 'create' && renderCreateNewPortal()}
      {method === 'select' && renderSelectPortal()}
      <span className="portal-span">
        <a className="portal-method-switch" onClick={handleChangeMethod}>
          {method === 'create' ? 'Select an existing' : 'Create a new'} portal
        </a>
      </span>
    </div>
  );
};

export default CreatePortalBody;
